





































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import PaidDeselectionWarning from '@/components/common/PaidDeselectionWarning'
import LibraryValidationRule from '@/classes/rules/LibraryValidationRule'
import Pagination from "@/classes/Pagination"
import { LibraryType } from '@/classes/enums/LibraryType'
import Organization from "@/classes/Organization";

@Component({
  components: {
    PaidDeselectionWarning,
  },
})
export default class OrganizationLibraries extends Vue {
  @Prop(Object) public organization: Organization;

  private selectedLibrary: object = {}
  private warningDialog: boolean = false
  private perPageOptions: Array = [5, 25, 50, 100]
  private libraryValidationRule: LibraryValidationRule = new LibraryValidationRule()
  private valid: boolean = false

  private get getPaginationLength() {
    return Math.ceil(this.totalCount / this.pagination.itemsPerPage)
  }

  private get orgId() {
    return this.organization.id
  }

  private get librariesToUpdate() {
    return this.$store.getters['libraries/getLibrariesToUpdate']
  }
  private set librariesToUpdate(val) {
    this.$store.commit('libraries/setLibrariesToUpdate', val)
  }

  public get libraries() {
    let libs = this.$store.getters['libraries/getLibraries']
    for (let l of libs) {
      const idx = this.librariesToUpdate.findIndex((o: object) => o.id === l.id)
      if (idx !== -1) {
        l.type = this.librariesToUpdate[idx].type
        l.requirePurchase = this.librariesToUpdate[idx].requirePurchase
        l.subscriptionPrice = this.librariesToUpdate[idx].subscriptionPrice
      }
    }

    return libs
  }
  public set libraries(val) {
    this.$store.commit('libraries/setLibraries', val)
  }

  private get pagination() {
    return this.$store.getters['libraries/getPagination']
  }
  private set pagination(val) {
    this.$store.commit('libraries/setPagination', val)
  }

  private get query() {
    return this.$store.getters['libraries/getQuery']
  }
  private set query(val) {
    this.$store.commit('libraries/setQuery', val)
  }

  private get totalCount() {
    return this.$store.getters['libraries/getTotalLibraryCount']
  }

  private close() {
    this.warningDialog = false
    this.selectedLibrary = {}
  }

  private publicChange(checked, library) {
    if (checked) {
      library.type = 200
    } else {
      library.type = 100
      library.requirePurchase = false
      library.subscriptionPrice = 0
    }
    this.pushLibraryIfNotFound(library)
  }

  private paidSubscriptionChange(checked, library) {
    if (checked === false) {
      this.selectedLibrary = library
      this.warningDialog = true
    } else {
      library.cost.isPaidLibrary = true
      this.paidSelected(checked, library)
    }
  }

  private paidSelected(checked, library) {
      // library.requirePurchase = checked
      // library.type = checked ? 200 : 100
      if (checked && library.cost.price !== 0) {
        this.pushLibraryIfNotFound(library)
      } else if (!checked && library.type === LibraryType.Purchased) {
        library.cost.isPaidLibrary = false
        library.cost.price = 0
        library.cost.endRange = 0
        library.cost.startRange = 0
        // TODO: Revisit this; may want to change to dropdown instead of checkbox to include all 3 options
        library.type = 100
        this.pushLibraryIfNotFound(library)
      }
      this.warningDialog = false
      this.selectedLibrary = {}
  }

  private priceChange(price, library) {
    library.subscriptionPrice = price
    this.pushLibraryIfNotFound(library)
  }

  private startRangeChange(price, library) {
    library.subscriptionPrice = price
    this.pushLibraryIfNotFound(library)
  }

  private endRangeChange(price, library) {
    library.subscriptionPrice = price
    this.pushLibraryIfNotFound(library)
  }

  private pushLibraryIfNotFound(library) {
    const idx = this.librariesToUpdate.findIndex((o: object) => o.id === library.id)
    if (idx !== -1) {
      this.librariesToUpdate.splice(idx, 1)
    }
    this.librariesToUpdate.push(library)
  }

  private changePage() {
    this.$store.dispatch('libraries/searchLibrariesAsync', this.orgId)
  }

  private search() {
    this.pagination.page = 1
    this.$store.dispatch('libraries/searchLibrariesAsync', this.orgId)
  }

  private updateLibraries() {
    this.$store.dispatch('libraries/updateLibrariesAsync', this.librariesToUpdate)
  }

  private mounted() {
    this.$store.commit('libraries/resetQueryValues', this.orgId)
    this.$store.dispatch('libraries/searchLibrariesAsync', this.orgId)
  }
}
